import { SURVEY_SERIES_LIST, SURVEY_SERIES_LIST_ERROR, SURVEY_SERIES_LIST_SUCCESS, SURVEY_SERIES_UPDATE_DATA } from './constants';

export default function surveySeriesReducer(state, action) {
	let pagination = {};
	switch (action.type) {
	case SURVEY_SERIES_LIST :
		return { ...state, loading : true, error : false };
	case SURVEY_SERIES_LIST_SUCCESS :
		if(action.payload && action.payload.length > 0 ){
			pagination.total = action.payload.total ? action.payload.total : 0;
			pagination.limit = action.payload.limit ? action.payload.limit : 10;
			pagination.skip = action.payload.skip ? action.payload.skip : 0;
			pagination.current = action.page ? action.page : 1;
			pagination.pageSize =  action.pageSize ? action.pageSize : 10;
			return { ...state, surveySeries : action.payload, loading : false, error : false,pagination: pagination};
		}else{
			if (action.payload && action.payload.length == 0) {
                        
				return { ...state, surveySeries: [], pending: false, error: false };
			} else {
    
				return { ...state, surveySeries: [] , pending: false, error: true };
			}
		}
	case SURVEY_SERIES_LIST_ERROR : 
		return { ...state, loading : false, error : true };
	case SURVEY_SERIES_UPDATE_DATA :
		return { ...state, updateData : action.payload };
	default: {
		throw Error('Unknown action: ' + action.type);
	}
	}
}